import Ajax from '@/lib/ajax'
export default {
    /**
     * 创建积分游戏活动
     * @param data 
     */
    addRewardPointGame(data: any) {
        return Ajax.post(`/api/MarketingManagement/RewardPointGame`, data)
    },
    /**
     * 更新积分游戏活动
     * @param id 
     * @param data 
     */
    updateRewardPointGame(id: string, data: any) {
        return Ajax.put(`/api/MarketingManagement/RewardPointGame/${id}`, data)
    },
    /**
     * 获取积分活动信息
     * @param id 
     */
    getRewardPointGame(id: string) {
        return Ajax.get(`/api/MarketingManagement/RewardPointGame/${id}`)
    },
    /**
     * 获取积分游戏列表
     */
    getRewardPointGameList(MaxResultCount: number, currentPage: number, Type?: number, Name?:string, Sorting?: string) {
        return Ajax.get(`/api/MarketingManagement/RewardPointGame`, {
            params: {
                MaxResultCount,
                SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
                Type,
                Name,
                Sorting
            }
        })
    }
}